const SET_EXAM_RESULT = '[exam][result]set';

export {SET_EXAM_RESULT}